
const digest = '53bf26212cb0ab556f162ded1912897dbc8a348a92fcc6e12a899b3d595f4689';
const classes = {"wrapper":"_wrapper_1vq57_1","item":"_item_1vq57_7"};
const css = `._wrapper_1vq57_1 {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

._item_1vq57_7 {
  overflow-wrap: break-word;
}
._item_1vq57_7 :not(:last-child)::after {
  content: " - ";
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  